<template>
    <div class="advantage-item">
        <div class="container-image-advantage d-flex align-items-center">
            <img class="advantage-item-image" :src="item.icon" alt="advantage" />
        </div>
        <div>
            <span class="advantage-item-description">{{ item.title }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{ item: { title: string; icon: string } }>();
</script>

<style lang="scss" scoped>
.advantage-item {
    max-width: 21.8rem;
    width: 46%;
    min-height: 6.25rem;
    display: flex;
    flex-direction: row;
    gap: 1.25rem;
    align-items: center;
}
.advantage-item-description {
    color: var(--main-black-2-b-2-b-2-b, #2b2b2b);
    /* paragraph/16-26 */
    font-family: Roboto;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.625rem; /* 162.5% */
}
.container-image-advantage {
    max-width: 6.25rem;
    max-height: 6.25rem;
    width: 100%;
    height: 100%;
}

@media (max-width: 768px) {
    .advantage-item {
        align-items: flex-start;
        gap: 20px;
        max-width: 100%;
        width: 100%;
        min-height: 60px;
    }

    .container-image-advantage {
        width: 60px;
        height: 60px;
    }
    .advantage-item-image {
        width: 60px;
        height: 60px;
    }

    .advantage-item-description {
        font-size: 16px;
        line-height: 26px;
    }

}
</style>
